import { FC, useMemo } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import { parseParametrizationPurchaseCronogramaExport } from '@helper/grid/parametrization-purchase'

import PurchaseCsvExportItem, {
  PurchaseCsvColumn
} from './PurchaseCsvExportItem'

interface IProps {
  data?: any[]
}

// Mesmas colunas do upload de cronograma
const COLUMNS: PurchaseCsvColumn[] = [
  'Empresa - Codigo',
  'Centro - Nome',
  'Centro - Codigo',
  'Fornecedor - Nome',
  'Fornecedor - Codigo',
  'CategoriaCompacta - Nome',
  'CategoriaCompacta - Codigo',
  'Dia - Semana',
  'Usuario - Email'
].map(header => ({ header, field: header }))

// Agora via exportToCSV (antes: CSVLink sem proteção contra fórmula)
const ActionExcelPurchaseCronogramaExport: FC<IProps> = ({ data = [] }) => {
  const { selectedCompradorEmail } = useParametrizationConfigPurchase()
  const total = Array.isArray(data) ? data.length : 0

  const getRows = useMemo(
    () => () =>
      parseParametrizationPurchaseCronogramaExport(
        data,
        selectedCompradorEmail
      ),
    [data, selectedCompradorEmail]
  )

  return (
    <PurchaseCsvExportItem
      filenamePrefix="cronograma-compra"
      columns={COLUMNS}
      getRows={getRows}
      rowCount={total}
      label={`Exportar Cronograma (${total})`}
    />
  )
}

export default ActionExcelPurchaseCronogramaExport
